/* Hamakija — Współpraca: a link with [data-hk-coop-type="…"] preselects that option in the enquiry form
   (select[data-hk-coop-select]) before jumping to it. Also honours ?typ=… in the URL. */
(() => {
  if (window.hkCoopInit) return;
  window.hkCoopInit = true;
  const pick = (value) => {
    if (!value) return;
    const v = value.toLowerCase();
    document.querySelectorAll('select[data-hk-coop-select]').forEach((sel) => {
      const opt = [...sel.options].find((o) => o.value.toLowerCase() === v || o.value.toLowerCase().startsWith(v));
      if (opt) sel.value = opt.value;
    });
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-hk-coop-type]');
    if (a) pick(a.dataset.hkCoopType);
  });
  const init = () => {
    try { pick(new URLSearchParams(window.location.search).get('typ')); } catch (_) { /* ignore */ }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
